import { render, staticRenderFns } from "./VacationsForm.vue?vue&type=template&id=9d122b98&"
import script from "./VacationsForm.vue?vue&type=script&lang=js&"
export * from "./VacationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports